export const SITE = {
  name: "James Pratt — Entrepreneur",
  company: "1-800-Busy Dog Basement Technologies",
  tagline: "Serial Entrepreneur. Innovator. Author.",
};

export const NAV_LINKS = [
  { label: "About", hash: "#about" },
  { label: "Timeline", hash: "#timeline" },
  { label: "Testimonials", hash: "#testimonials" },
];

export const HERO = {
  kicker: "Serial Entrepreneur. Innovator. Author.",
  headline: "BUILT MULTIPLE BASEMENT WATERPROOFING ENTERPRISES FROM THE GROUND UP.",
  subhead:
    "James Pratt founded 1-800-Busy Dog Basement Technologies in 1989, developed a line of patented basement waterproofing systems, formed Busy Dog University in 2001 and built an international network of up to 70 trained dealers across the U.S. and Canada.",
  ctaLabel: "About James Pratt",
  ctaTo: "/about",
  badges: [
    { icon: "award", text: "35 Years in Basement Waterproofing" },
    { icon: "file", text: "16 Patents in Basement Waterproofing & Remodeling" },
    { icon: "stamp", text: "40+ Registered Trademarks (U.S. & Canada)" },
    { icon: "users", text: "70 Trained Dealers Across the U.S. & Canada" },
  ],
  youtube: {
    label: "Watch on YouTube",
    title: "Busy Dog Basement Technologies",
    byline: "YouTube Channel",
    url: "https://youtube.com/BasementTechnologies",
  },
};

export const TRUSTED = {
  label: "Dealers trained across the U.S. and Canada.",
};

export const CREDIBILITY = {
  headline:
    "I BUILT A BUSINESS ON PATENTED SYSTEMS, TRAINED DEALERS, AND HANDS-ON PRODUCT DEVELOPMENT.",
  quote:
    "Understanding the problem and fixing it intelligently with constant communication to the customer during each project is the cornerstone of our company.",
  blockTitle: "Built From the Ground Up.",
  blockBody:
    "James Pratt started as a carpenter, ran five businesses at once by 1989, then focused exclusively on basement waterproofing to build a patented product line and an international dealer network.",
  ctaLabel: "Read the Full Story",
  ctaTo: "/about",
};

export const WHAT_I_DO = {
  kicker: "Where Innovation Becomes Real-World Solutions",
  headline: "Inside 1800 Busy Dog Basement Technologies",
  areas: [
    {
      num: "01",
      heading: "A Creative Foundation, Structural Repair Methods",
      short: "Developing practical basement waterproofing systems and solutions for basement water problems.",
      paragraphs: [
        "James Pratt built his career around basement waterproofing, foundation repair and Radon mitigation structural repair after years of experience in construction and remodeling. Through his work in the field, he identified opportunities to improve existing waterproofing designs and systems. Groundworks now owns the entire operation and continues to work toward this goal.",
        "He began developing proprietary products and concepts for the basement waterproofing industry, eventually building a business around specialized waterproofing systems, products and procedures. This work is now owned by Groundworks.",
        "Basement Technologies developed products, systems and services specifically for the basement waterproofing industry. Historical company materials describe its products as being developed, tested and refined over time, with patented products and systems used through its dealer network.",
        "This work reflects James Pratt's history prior to 1-800-Busy Dog Basement Technologies joining forces with Groundworks in 2025.",
      ],
      anchor: {
        text: "Explore Basement Waterproofing Systems",
        url: "https://www.basementtechnologies.com/",
      },
      image: {
        src: "/assets/waterproofing-trench-installation.jpg",
        alt: "Technician digging an exterior foundation drainage trench during a basement waterproofing installation",
      },
    },
    {
      num: "02",
      heading: "Product Development & Patents",
      short: "Turning field experience into proprietary products and patented solutions.",
      paragraphs: [
        "James Pratt's work in basement waterproofing led him to focus heavily on product development and innovation.",
        "After identifying limitations in existing waterproofing designs and systems, he began researching, developing and patenting products for the industry. Groundworks now continues this mission and owns the company.",
        "His approach combined hands-on construction experience with research and product development, allowing him to develop solutions based on practical problems encountered in the field.",
        "The available biographical information associated with James Pratt records 16 patents and 40 trademarks, with none currently pending.",
        "James Pratt's patented products came directly from decades of hands-on fieldwork in basement waterproofing.",
      ],
      anchor: {
        text: "Explore Patented Products & Technologies",
        url: "https://www.globenewswire.com/news-release/2010/08/25/428352/13217/en/Basement-Technologies-Inc-Signs-Exclusive-Licensed-Dealer-Agreement-With-Terminix-Services-Inc.html",
      },
    },
    {
      num: "03",
      heading: "Dealer Network & Franchise Training",
      short: "Creating a repeatable business model built around systems, training and dealer support.",
      paragraphs: [
        "James Pratt developed more than products and waterproofing systems. He also developed a structured business model that could be replicated by other contractors.",
        "He created procedural books and manuals covering areas such as sales, marketing, administration, production, warehouse operations and general business practices. All of these are now owned by Groundworks.",
        "The model was based on his own local operation and became the foundation for an international dealer network.",
        "The dealer model combined standardized procedures, training, proprietary products and business systems so that independent dealers could operate using a consistent framework, which is now done by Groundworks.",
        "Historical company announcements describe Basement Technologies' licensed dealer network and its ongoing education and support for dealers, including training, marketing support and access to proprietary products and services, which is now done by Groundworks.",
        "Starting in 1999, James Pratt licensed his system to independent contractors across the U.S. and Canada, patterning every dealer on his own New England company. In 2001, he formed Busy Dog University to train dealers in product theory, installation, sales and marketing. The network grew to up to 70 dealers, each typically employing 10 to 15 people.",
      ],
      anchor: {
        text: "Explore the Dealer Network & Training Model",
        url: "https://www.globenewswire.com/de/news-release/2010/08/25/428351/13217/en/basement-technologies-inc-signs-exclusive-licensed-dealer-agreement-with-kent-companies-inc.html",
      },
    },
    {
      num: "04",
      heading: "Business Building",
      short: "Building a specialized business through construction experience, systems and entrepreneurship.",
      paragraphs: [
        "James Pratt's entrepreneurial career began in construction and remodeling.",
        "He started his construction/subcontracting business in the 1980s and later expanded into several construction-related businesses, including remodeling, commercial construction, steel buildings, fire and water damage restoration, reconstruction and basement waterproofing.",
        "He eventually chose to focus his attention on basement waterproofing.",
        "That focus allowed him to combine construction experience with product development, operational procedures, training and dealer development. All operations are now under Groundworks.",
        "The business evolved from a local operation into a larger dealer-based model supported by standardized procedures, technology and business systems.",
        "A 2015 industry announcement describes 1-800-Busy-Dog's focus on technology designed to help its dealer network manage operations, reduce costs and increase sales. All operations are continued now under Groundworks.",
        "This work reflects James Pratt's history prior to 1-800-Busy Dog Basement Technologies joining forces with Groundworks in 2025.",
        "From a single remodeling outfit to a specialized foundation repair company active in commercial construction, Pratt built a business around systems, training, and entrepreneurship.",
      ],
      anchor: {
        text: "Explore the Business-Building Journey",
        url: "https://www.pr.com/press-release/619885",
      },
      logo: {
        src: "/assets/basement-technologies-original-logo.png",
        alt: "Original Basement Technologies and 1-800-Busy Dog brand logo",
        caption:
          "Original Basement Technologies brand identity, developed as the company grew across New England.",
      },
    },
  ],
};

export const PRESS = {
  eyebrow: "PRESS",
  heading: "IN THE NEWS",
  articles: [
    {
      kicker: "EXTERNAL COVERAGE",
      headline:
        "Groundworks Continues Growth Trajectory With Its First Location in Massachusetts",
      byline: "Groundworks Newsroom · April 2, 2025",
      summary:
        "Coverage of James Pratt joining forces with Groundworks in 2025, extending Busy Dog Basement Technologies' waterproofing and foundation repair services to homeowners across Massachusetts and Rhode Island under the Groundworks name.",
      cta: "Read the Full Article",
      url: "https://www.groundworks.com/2025/04/02/groundworks-continues-growth-trajectory-with-its-first-location-in-massachusetts/",
    },
  ],
};

export const TESTIMONIALS = {
  heading: "TESTIMONIALS",
  categories: [
    {
      heading: "Customer Reviews for the Service",
      slug: "service",
      videos: [
        { id: "ttgT5_wzzIY", title: "Customer review of the service, video 1" },
        { id: "b1iikhS9LIA", title: "Customer review of the service, video 2" },
        { id: "cSQNnf43bqE", title: "Customer review of the service, video 3" },
      ],
    },
    {
      heading: "Customer Reviews for Dealer Training",
      slug: "dealer-training",
      videos: [
        { id: "nD6bFBMLEt4", title: "Customer review of dealer training, video 1" },
        { id: "plL9FDakMCA", title: "Customer review of dealer training, video 2" },
        { id: "ttgT5_wzzIY", title: "Customer review of dealer training, video 3" },
      ],
    },
  ],
};

export const CLOSING = {
  headlineLines: ["DECADES OF CUSTOMERS.", "SYSTEMS BUILT TO LAST."],
};

export const MARQUEE_ITEMS = [
  "Serial Entrepreneur",
  "Innovator",
  "Author",
  "Est. 1989",
  "1-800-Busy Dog Basement Technologies",
];

export const BOOK = {
  label: "Forthcoming Book",
  title: "Why a Basement Leaks",
  supporting:
    "In Why a Basement Leaks and How to Fix It Permanently, James Pratt explains the most common basement leak causes and shows homeowners how to waterproof a basement for good.",
  cover: "/assets/why-a-basement-leaks-cover.png",
  pdf: "/assets/why-a-basement-leaks-book.pdf",
  cue: "Click to Read",
};

export const QUOTE = {
  text: "Understanding the problem and fixing it intelligently with constant communication to the customer during each project is the cornerstone of our company. We will settle for nothing less than 100% customer satisfaction.",
  attribution: "James Pratt, Founder",
};

export const BIO_NARRATIVE = {
  paragraphs: [
    "He earned a Bachelor of Science in Applied Technology from the Florida Institute of Technology, along with two-year associate degrees in Offshore Marine Technology and Petroleum Technology. He worked as a carpenter and in a bar through college, starting in 1982.",
    "In 1984, he started his own remodeling business, and in the mid-1980s relocated to the Boston area. In 1989, he added basement waterproofing to the business, the origin of what became 1-800-Busy Dog Basement Technologies. In 1994, he purchased a fire and water damage restoration franchise and added a radon mitigation license, and in 1998 he began steel building installation and commercial construction work.",
    "By 1999, Pratt had stopped his other ventures to focus exclusively on basement waterproofing and taking over the commercial construction work. Pratt continued expanding the business over the next two decades. In 2015, he expanded into foundation repair, adding foundation piering and structural repair alongside basement waterproofing. In 2018, he restarted his fire and water damage restoration business and launched a water purification system business. In 2019, he expanded further into remodeling, home piering, mudjacking (also called slabjacking), and foundation slab repair and replacement. He also authored \"Why a Basement Leaks and How To Fix It Permanently!\", a consumer guide on the causes of basement water infiltration and how different waterproofing methods compare. James authored multiple \"Procedure Manuals\" on how to operate each business.",
    "James Pratt built two businesses on his patented basement waterproofing systems: a local waterproofing company serving New England and an international network of up to 70 trained dealers across the U.S. and Canada.",
    "The local basement waterproofing company, led by its flagship Boston Basement Technologies, managed every waterproofing project from start to finish. It manufactured and installed only its own patented waterproofing products, used its own trained and certified technicians and gave each homeowner a dedicated Project Manager. From 2005 to 2008, the business had upwards of 100 employees.",
    "The dealer network followed the franchise model James learned from his earlier restoration franchise. Each dealer was licensed and certified by the Basement Technologies corporate office and trained through Busy Dog University at the company's training center in Massachusetts. Dealers then installed the same 1-800-Busy Dog products, including the Water Trek Aqua Route® System, Powerhouse Turbo sump pumps, Stallion Eliminator® II battery backup and Air Mop® III dehumidifiers.",
  ],
  statusLabel: "Where Things Stand Today",
  status:
    "In 2025, 1-800-Busy Dog Basement Technologies joined forces with Groundworks. The business continues serving Massachusetts and Rhode Island homeowners under the Groundworks name. All of Pratt's patents, dealer networks, and customers were transferred to Groundworks.",
};

export const TIMELINE_SHORT = [
  { year: "1982", tag: "First framing job" },
  { year: "Mid-1980s", tag: "Started remodeling business" },
  { year: "1989", tag: "1-800-Busy Dog founded" },
  { year: "1994", tag: "Fire & water restoration franchise" },
  { year: "1998", tag: "Steel building installation and commercial construction begin" },
  { year: "1999", tag: "Focused solely on waterproofing" },
  { year: "2001", tag: "Busy Dog University formed" },
  { year: "2015", tag: "Foundation repair, piering, and structural work added" },
  { year: "2018", tag: "Restoration & water purification restart" },
  { year: "2019", tag: "Remodeling & piering expansion" },
  { year: "2025", tag: "Joined forces with Groundworks" },
];

export const FOOTER = {
  tagline: "Serial Entrepreneur. Innovator. Author.",
  disclosure:
    "This is the personal website of James Pratt. It is independent of, and distinct from, the corporate website of 1-800-Busy Dog Basement Technologies / Groundworks. A link to the company site will be added once the correct current URL is confirmed.",
};
